import PropTypes from 'prop-types';
import React from 'react';
import BaseContainer from '../baseContainers/BaseContainer';
import {CustomMessages} from '../components/CustomMessages';
import SimpleReactValidator from '../components/validator';
import BlockUi from '../components/waitPanel/BlockUi';
import SupeMoyaService from '../services/SupeMoyaRegistrationService';

class SuperMoyaEmailConfirmationContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.service = new SupeMoyaService();
        this.state = {
            resultRendered: false,
            resultType: undefined,
            resultMessage: undefined,
        };
        this.validator = new SimpleReactValidator({}, this.translate);
    }

    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        this.service
            .emailConfirm(this.props.token)
            .then((res) => {
                this.setState({
                    resultType: 'success',
                    resultMessage: 'Dziękujemy,<br />Twój adres e-mail został potwierdzony',
                    resultMessageDesc: 'Szerokiej drogi!',
                });
                this.unblockUi();
            })
            .catch((err) => {
                this.setState({
                    resultType: 'error',
                    resultMessage: 'Błąd autoryzacji',
                    resultMessageDesc: 'Coś poszło nie tak',
                });
                this.unblockUi();
            });
    }

    render() {
        const {resultMessage, resultType, resultMessageDesc} = this.state;
        return (
            <React.Fragment>
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <div id='main'>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)}></CustomMessages>
                        <div className='app-container'>
                            <div className='title-container'>
                                <img src='/images/super_moya_logo.svg' className='logo' alt='logo moya' />
                            </div>
                            <div className='title-container'>
                                {resultType ? (
                                    <img
                                        src={`/images/${resultType === 'success' ? 'success_ico' : 'error_ico'}.svg`}
                                        className='logo'
                                        alt='result icon'
                                    />
                                ) : null}
                            </div>
                            <div className='row'>
                                <div className='title'>
                                    <label className='text' dangerouslySetInnerHTML={{__html: resultMessage}} />
                                </div>
                            </div>
                            <div className='result-container'>
                                <span className='text' dangerouslySetInnerHTML={{__html: resultMessageDesc}} />
                            </div>
                        </div>
                    </div>
                </BlockUi>
            </React.Fragment>
        );
    }
}

SuperMoyaEmailConfirmationContainer.propTypes = {
    token: PropTypes.string,
};

export default SuperMoyaEmailConfirmationContainer;
